var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdobeCommerceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0000;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,7h155C229,7,248,26.7,248,51.1v154.7c0,24.4-19,44.1-42.5,44.1h-155C27,250,8,230.3,8,205.9V51.1 C8,26.7,27,7,50.5,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162968",
    className: "st1",
    d: "M214.7,204.6h-38.6c-3.4,0.1-6.6-2-7.9-5.1l-41.9-97.9c-0.3-1-1.3-1.5-2.3-1.3c0,0,0,0,0,0 l0,0c-0.6,0.2-1.1,0.6-1.2,1.2l-26.1,62c-0.5,1.1,0,2.4,1.2,2.9c0,0,0,0,0,0l0,0c0.3,0.1,0.6,0.2,0.9,0.2h28.7 c1.8,0,3.4,1.1,4.1,2.7l12.6,28c1.1,2.6-0.1,5.6-2.7,6.8l0,0c-0.6,0.3-1.3,0.4-2,0.4H34.8c-2.6,0-4.7-2.1-4.7-4.7 c0-0.6,0.1-1.3,0.4-1.8L96.9,39.6c1.4-3.4,4.7-5.7,8.4-5.6h38.4c3.7-0.1,7.1,2.2,8.4,5.6l66.9,158.3c1.1,2.4,0,5.2-2.4,6.3l-0.1,0.1 C216,204.5,215.4,204.6,214.7,204.6L214.7,204.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeCommerceLogo);
export default __webpack_public_path__ + "static/media/adobe-commerce-logo.d0d6eb82162bf6c5b43a9f773538477c.svg";
export { ForwardRef as ReactComponent };